/**
 *
 * A Common master service for all http request
 * @Author <ghanshyam.tank@softwebsolutions.com>
 * @Author <bharat.chauhan@softwebsolutions.com>
 *
 **/
import { Injectable } from "@angular/core";
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/delay';
import { ActivatedRoute, Router } from '@angular/router';
import { Http } from "@angular/http";
import { Headers } from "@angular/http";
import { AuthService } from '../../auth/services/auth.service';
import { Constants } from '../../constants';
import { NotificationService, Notification } from '../../common/services/notifications.service';
import { HttpErrorResponse } from '@angular/common/http';
declare var $: any;
@Injectable()
export class HttpClient {
	requestUrl: string;
	responseData: any;
	handleError: any;
	constructor(private _notificationService: NotificationService, private router: Router, private http: Http, private constants: Constants, private _authService: AuthService) {
		this.http = http;
	}
	/**
	 * Set Header Parameter for Http request
	 * @Author <ghanshyam.tank@softwebsolutions.com>
	 * @Return Json Response
	 **/
	createAuthorizationHeader(headers: Headers, currentUrl: string) {
		$('.loader_container').css('display', 'block');
		if (this._authService.getJwtToken() && this._authService.getLoginUserInfo() && this._authService.getLocalStorageMenu()) {
			this.requestUrl = this.constants.baseAuthUrl;
			headers.append('Authorization', 'Bearer ' + this._authService.getJwtToken());
			headers.append('currentUrl', currentUrl);
			if (this._authService.getLoginUserInfo().isClone == '1') {
				headers.append('isClone', this._authService.getLoginUserInfo().isClone);
			}
		} else {
			this.requestUrl = "";
		}
	}
	/**
	 * Http request for get data
	 * @Author <bharat.chauhan@softwebsolutions.com>
	 * @Return Json Response
	 * */
	get(url, currentUrl = undefined) {
		let headers = new Headers();
		this.createAuthorizationHeader(headers, currentUrl);
		if (this.requestUrl != "") {
			return new Promise((resolve, reject) => {
				this.http.get(this.requestUrl + url, {
					headers: headers
				}).subscribe(
					res => {
						this.responseData = res.json();
						this.customResponseHandler(this.responseData);
						resolve(this.responseData);
					},
				
					(error: HttpErrorResponse) => {

						const errorStatus = error.status;
						if (errorStatus === 504) {
							// Handle 504 Gateway Timeout
							console.error('HTTP 504 Gateway Timeout:', error);
							$('.loader_container').css('display', 'none');
							$('.custom_container').css('display', 'none');
							this._notificationService.add(new Notification('error', 'Gateway Timeout: The server took too long to respond.'));
							// Optionally, you can implement retry logic here
							reject(error);
						} else if (errorStatus !== 200) {
							// Handle other HTTP errors
							console.error('HTTP error status:', errorStatus);
							$('.loader_container').css('display', 'none');
							$('.custom_container').css('display', 'none');
							this._notificationService.add(new Notification('error', 'SOMETHING_WENT_WRONG'));
							reject(error);
						}

					}
				);
			});
		} else {
			this.router.navigate(['/login']);
		}
	}
	customResponseHandler(responseData: any) {
		$('.loader_container').css('display', 'none');
		if (responseData.error && responseData.redirect == 'login') {
			this._authService.logout();
			this.router.navigate(['/login']);
		}
	}
	customErrorHandler(error: any) {
		//$('.loader_container').css('display','none');
		var resData = error.json();
		if (error.status === 404 && resData.newToken) {
			/*this._cookieService.put('site_token', resData.newToken);
			this.configSetup();
			this.router.navigate(['/']);
			return false;*/
		}
	}

	configSetup() {
		$.ajaxSetup({
			headers: { 'Authorization': 'Bearer ' + this._authService.getJwtToken() },
			beforeSend: function (xhr) {
				// $('.loader_container').css('display','block');
			},
			complete(xhr, status) {
				// $('.loader_container').css('display','none');
			},
			statusCode: {
				404: function (xhr, status, error) {
				}
			}
		})
	}
	/**
	 * Http request for post data
	 * @Author <bharat.chauhan@softwebsolutions.com>
	 * @Return Json Response
	 */
	post(url, data, currentUrl = undefined) {
		return new Promise((resolve, reject) => {
			let headers = new Headers();
			this.createAuthorizationHeader(headers, currentUrl);
			if (this.requestUrl != "") {
				this.http.post(this.requestUrl + url, data, {
					headers: headers
				}).subscribe(
					(res: any) => {
						// Check if the response is JSON
						if (res && res.json) {
							this.responseData = res.json();
							this.customResponseHandler(this.responseData);
							resolve(this.responseData);
						} else {
							// Handle non-JSON response (e.g., HTML error page)
							reject({
								status: res.status,
								error: 'Non-JSON response received'
							});
						}
					},
					(error: HttpErrorResponse) => {

						const errorStatus = error.status;
						if (errorStatus === 504) {
							// Handle 504 Gateway Timeout
							console.error('HTTP 504 Gateway Timeout:', error);
							$('.loader_container').css('display', 'none');
							$('.custom_container').css('display', 'none');
							this._notificationService.add(new Notification('error', 'Gateway Timeout: The server took too long to respond.'));
							// Optionally, you can implement retry logic here
							reject(error);
						} else if (errorStatus !== 200) {
							// Handle other HTTP errors
							console.error('HTTP error status:', errorStatus);
							$('.loader_container').css('display', 'none');
							$('.custom_container').css('display', 'none');
							this._notificationService.add(new Notification('error', 'SOMETHING_WENT_WRONG'));
							reject(error);
						}

					}
				);
			} else {
				this.router.navigate(['/login']);
			}
		});
	}

	/**
	* Http request for post data with files
	* @Author <vipul.jadvani@softwebsolutions.com>
	* @Return Json Response
	*/
	fileUpload(url: string, postData: any, files: File[], currentUrl = undefined) {
		let headers = new Headers();
		this.createAuthorizationHeader(headers, currentUrl);
		return new Promise((resolve, reject) => {
			if (this.requestUrl != "") {
				let formData: FormData = new FormData(),
					xhr: XMLHttpRequest = new XMLHttpRequest();
				if (postData) {
					for (var key in postData) {
						var value = postData[key];
						formData.append(key, value);
					}
				}
				if (files != undefined) {
					for (let i = 0; i < files.length; i++) {
						formData.append("uploads[]", files[i], files[i].name);
					}
				}
				xhr.onreadystatechange = () => {
					if (xhr.readyState === 4) {
						if (xhr.status === 200) {
							this.responseData = JSON.parse(xhr.response);
							this.customResponseHandler(this.responseData);
							resolve(this.responseData);
						} else {
							// $('.loader_container').css('display','none');
							resolve(this.responseData);
						}
					}
				};
				xhr.open('POST', this.requestUrl + url, true);
				xhr.setRequestHeader('Authorization', 'Bearer ' + this._authService.getJwtToken());
				xhr.setRequestHeader('currentUrl', currentUrl);
				if (this._authService.getLoginUserInfo().isClone == '1') {
					xhr.setRequestHeader('isClone', this._authService.getLoginUserInfo().isClone);
				}
				if (this.requestUrl != "") {
					xhr.send(formData);
				} else {
					this.router.navigate(['/login']);
				}
			} else {
				this.router.navigate(['/login']);
			}
		});
	}
	/**
	 * Http request for export files
	 * @Author <vipul.jadvani@softwebsolutions.com>
	 * @Return Json Response
	 */
	exportDownload(url: string, report_name: string) {
		return new Promise((resolve, reject) => {
			var xhr = new XMLHttpRequest();
			xhr.onload = function (e) {
				var a;
				if (xhr.readyState === 4 && xhr.status === 200) {
					// Trick for making downloadable link
					a = document.createElement('a');
					a.href = window.URL.createObjectURL(xhr.response);
					// Give filename you wish to download
					a.download = report_name + '.xlsx';
					a.style.display = 'none';
					document.body.appendChild(a);
					a.click();
					resolve(true);
				}
			};
			// Post data to URL which handles post request
			xhr.open("GET", url);
			xhr.setRequestHeader('Authorization', 'Bearer ' + this._authService.getJwtToken());
			xhr.responseType = 'blob';
			xhr.send();
		});
	}
}